import { getDevices, putDevice } from '../api';
import { fetchProfiles } from './profiles';
import { unselectDevice } from './map';

import { PROCESSING_SELECTION } from './map';

export const FETCH_DEVICES = 'FETCH_DEVICES';
export const PUT_DEVICE = 'PUT_DEVICE';

export const fetchDevices = (organisationId) => {
  return {
    type: FETCH_DEVICES,
    payload: getDevices(organisationId)
  }
}

export const updateDevice = (organisationId, device) => ({
  type: PUT_DEVICE,
  payload: putDevice(organisationId, device)
});

export const updateProfileIds = (organisationId, profileId) => (dispatch, getState) => {
  const device_ids = getState().ui.map.selected_device_ids;

  return dispatch({
    type: PROCESSING_SELECTION,
    payload: Promise.all(
      device_ids.map(d_id => {
        // CTL is not understanding PATCH method, but it looks like PUT is acting
        // as patch anyway, so we just send profile_id instead of the whole device model
        return dispatch(updateDevice(organisationId, { id: d_id, profile_id: profileId }))
          .then(d => dispatch(unselectDevice(d.value.id)))
      })
    )
  }).then(() => dispatch(fetchProfiles(organisationId)));
}

// export const updateProfileIds = (organisationId, profileId) => (dispatch, getState) => {
//   const device_ids = getState().ui.map.selected_device_ids;
//
//   return dispatch({
//     type: PROCESSING_SELECTION,
//     payload: device_ids.map(d_id => {
//       return dispatch(updateDevice(organisationId, { id: d_id, profile_id: profileId }))
//         .then(d => dispatch(unselectDevice(d.value.id)))
//     }).reduce((promiseChain, currentTask) => {
//       return promiseChain.then(chainResults =>
//         currentTask.then(currentResult =>
//             [ ...chainResults, currentResult ]
//         )
//     );}, Promise.resolve([]))
//   }).then(() => dispatch(fetchProfiles(organisationId)));
// }



// WEBPACK FOOTER //
// ./src/actions/devices.js